export default __webpack_public_path__ + "static/media/email.fc5421b5.svg";